var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { CustomFormElementResponseDto } from './custom-form-element.response.dto.js';
/**
 * Response DTO for CustomFormElementAnswer queries.
 * This is independent of the Domain Entity and optimized for the view.
 *
 * @remarks
 * Use this DTO instead of `CustomFormElementAnswerFullSizeDto` or `CustomFormElementAnswer` entity.
 * Those are deprecated in favor of dedicated Response DTOs.
 */
export class CustomFormElementAnswerResponseDto {
    id;
    createdAt;
    updatedAt;
    answer;
    index;
    customFormElementId;
    customFormAnswerId;
    customFormElement;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementAnswerResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormElementAnswerResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormElementAnswerResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], CustomFormElementAnswerResponseDto.prototype, "answer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CustomFormElementAnswerResponseDto.prototype, "index", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementAnswerResponseDto.prototype, "customFormElementId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementAnswerResponseDto.prototype, "customFormAnswerId", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormElementResponseDto),
    __metadata("design:type", CustomFormElementResponseDto)
], CustomFormElementAnswerResponseDto.prototype, "customFormElement", void 0);
//# sourceMappingURL=custom-form-element-answer.response.dto.js.map